export default __webpack_public_path__ + "static/westorage-ceo-94d1bfa1bb9eaa389b75b38e423c2e74.jpg";